import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';
import { SystemComponentEnum } from 'src/app/models/enums/systemComponent.enum';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from '@angular/router';
import { Toast, ToastrService } from 'ngx-toastr';

export enum SystemSourceEnum{
  BillingManagement = 0,
  AdminPanel = 1
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private pathApi = this.config.setting['pathApi'] + "auth/";
  private jwtService = new JwtHelperService();

  constructor(private http: HttpClient, private config: AppConfig, private router: Router, private toast: ToastrService) { }

  isPasswordTemp(loginData : any) {
    return this.http.post(`${this.pathApi}isPasswordTemp`,loginData);
  }
  logout() {
    return this.http.get(`${this.pathApi}connect/logout`);
  }
  
  sendMail(obj : any) {
    return this.http.post(`${this.pathApi}sendEmail`, obj);
  }
  
  forgotPasswordRequest(obj : any): Observable<any> {
    return this.http.post(`${this.pathApi}forgotPasswordRequest`, obj);
  } 
  changePassword(obj : any): Observable<any> {
    return this.http.post(`${this.pathApi}changePassword/`, obj);
  }

  login(loginForm: any, paramMap: string) : Observable<any> {
    const headers = new HttpHeaders()
  .set('Content-Type', 'application/json')
    return this.http.post<HttpResponse<any>>(this.pathApi+'login?' + paramMap, loginForm, {withCredentials: true});
  }

  loginAdmin(loginForm: Map<string, string>) : Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    loginForm.set('grant_type', 'password');
    const queryString = Array.from(loginForm.entries())
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
      return this.http.post(`${this.pathApi}connect/token?`, queryString, {withCredentials: true, headers: headers});

    }

  afterLogin(loginResponse: any) {
    
    localStorage.setItem('token', loginResponse.access_token);
    this.router.navigate(['']);
    
  }


  loginEntraAdmin(accessToken: string) : Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    let loginForm: Map<string, string> = new Map<string, string>();
    loginForm.set('entra_token', accessToken);
    loginForm.set('grant_type', 'entra_id');

    const queryString = Array.from(loginForm.entries())
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
      return this.http.post(`${this.pathApi}connect/token?`, queryString, {withCredentials: true, headers: headers});

  }

  getCurrentUserPermissionForPage(registerForm: any) {
    // return this.http.post('https://localhost:44334/api/auth/register', registerForm, {withCredentials: true});
  }
  public decodeJWTToken() {
    let token = localStorage.getItem('token');

    if (!token)
      return null;

    return this.jwtService.decodeToken(token);
  }

  public getCurrentUserPermissionCrudSettingsPage() {
    let rolePermissionAndSystemComponents = localStorage.getItem('rolePermissionAndSystemComponents');

    if (!rolePermissionAndSystemComponents)
      return false;

    let systemComponents = JSON.parse(this.jwtService.urlBase64Decode(rolePermissionAndSystemComponents)).SystemComponents;
    let filteredSystemComponents = systemComponents.filter(
      (x: { Name: string; })=> x.Name == SystemComponentEnum[SystemComponentEnum.TransmissionStation] 
                            || x.Name == SystemComponentEnum[SystemComponentEnum.MainFeeder]
                            || x.Name == SystemComponentEnum[SystemComponentEnum.InjectionSubstation]
                            || x.Name == SystemComponentEnum[SystemComponentEnum.SubFeeder]
                            || x.Name == SystemComponentEnum[SystemComponentEnum.DistributionTransformer]
                            || x.Name == SystemComponentEnum[SystemComponentEnum.Region]
                            || x.Name == SystemComponentEnum[SystemComponentEnum.Area]
    );

    if(filteredSystemComponents.length > 0)
      return filteredSystemComponents;

    return null;
  }
  
  isLoggedIn() {
    let token = localStorage.getItem('token');

    if (!token){
      //this.cookieService.removeAll();
      return false;
    }

    return !this.jwtService.isTokenExpired(token);
  }

  public isAdmin(){
    let token = localStorage.getItem('token');

    if (!token)
      return false;
    let isAdmin = this.jwtService.decodeToken(token)?.SystemSource == SystemSourceEnum[1];
    return true;
  }

  validateCode(validateCode : any): Observable<any> {
    return this.http.post<HttpResponse<any>>(this.pathApi+'validateCode', validateCode, {withCredentials: true});
  } 
  Is2FARequired(is2FARequired : any) {
    return this.http.post<HttpResponse<any>>(this.pathApi+'Is2FARequired', is2FARequired);
  }

  request2FA() {
    return this.http.post<HttpResponse<any>>(this.pathApi+'send2FACode',{});
  }
  
  verify2FAPage(code: string) {
    return this.http.post<HttpResponse<any>>(this.pathApi+'validateCodePage', { code: code });
  }
  
  is2FAVerified(): boolean {
    return localStorage.getItem('2FA_Verified') === 'true';
  }

  getPasswordLength(): Observable<any>{
    return this.http.get<any>(`${this.pathApi}getPasswordLength`);
  }
  
  set2FAVerified(status: boolean) {
    if (status) {
      localStorage.setItem('2FA_Verified', 'true');
    } else {
      localStorage.removeItem('2FA_Verified');
    }
  }
}
